import type { ImportTaxonomyNodesRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TAXONOMY_CHILDREN_QUERY_KEY } from './useGetTaxonomyChildren';

export const useImportTaxonomyNodes = (taxonomyId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (data: ImportTaxonomyNodesRequest) => api.taxonomy.importTaxonomyNodes(tenantId, taxonomyId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TAXONOMY_CHILDREN_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    importNodes: mutateAsync,
    isImporting: isPending,
    importError: getApiError(error),
  };
};
